<template>
  <vx-card no-shadow>
    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Title</span>
      </div>
      <div class="vx-col sm:w-3/5 w-full">
        <i8n-input v-if="lesson" label="" placeholder="Title..." :content.sync="lesson.title" class="w-full" />
      </div>
    </div>

    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <i8n-quill-editor v-if="lesson" label="" :content.sync="lesson.description" />
      </div>
    </div>

    <h5 class="mb-3">Participation rules</h5>
    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Define the minimum score for the participant to pass the lesson</span>
      </div>
      <div class="vx-col">
        <vs-input v-if="lesson" v-validate="'numeric'" name="requiredPerformanceScore" v-model="lesson.requiredPerformanceScore" />
        <div v-if="lesson" class="text-danger text-sm" v-show="errors.has('requiredPerformanceScore')">{{ errors.first('requiredPerformanceScore') }}</div>
      </div>
    </div>

    <h5 class="mb-3">Planning &amp; Timing</h5>
    <div class="vx-row mb-8">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Estimated time (in minutes) to complete the lesson</span>
      </div>
      <div class="vx-col">
        <vs-input v-if="lesson" v-validate="'numeric'" name="expectedDuration" v-model="lesson.expectedDuration" />
        <div v-if="lesson" class="text-danger text-sm" v-show="errors.has('expectedDuration')">{{ errors.first('expectedDuration') }}</div>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <TypedSurveyImages v-if="lesson" 
      :item="lesson" 
      :assetUrl="'OnlineTraining/' + this.surveyId + '?moduleId=' + this.moduleId + '&lessonId=' + this.lessonId"
      style="width: 100%;" />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Other Files</h5>
    </div>
    <TypedSurveyFiles v-if="lesson" 
      :item="lesson" 
      :assetUrl="'OnlineTraining/' + this.surveyId + '?moduleId=' + this.moduleId + '&lessonId=' + this.lessonId"
      style="width: 100%;" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>

const TypedSurveyImages = () => import("./../../../components/TypedSurveyImages.vue");
const TypedSurveyFiles = () => import("./../../../components/TypedSurveyFiles.vue");

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    TypedSurveyImages,
    TypedSurveyFiles,
    quillEditor
  },
  props: {
    lesson: Object
  },
  data () {
    return {
      surveyId: '',
      moduleId: '',
      lessonId: '',
      
      name: ''
    }
  },
  methods: {
    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      const payload = {
        title: this.lesson.title,
        description: this.lesson.description,
        requiredPerformanceScore: parseInt(this.lesson.requiredPerformanceScore),
        canRedoLesson: this.lesson.canRedoLesson,
        expectedDuration: parseInt(this.lesson.expectedDuration)
      }

      console.log(payload);

      this.$http.put(process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId + '/modules/' + this.moduleId + '/lessons/' + this.lessonId + '/info/general', payload)
          .then(resp => {
            console.log(resp.data);

            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Lesson saved'
            });
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save lesson: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  created() {
    this.surveyId = this.$route.params.surveyId;
    this.moduleId = this.$route.params.moduleId;
    this.lessonId = this.$route.params.lessonId;

    console.log('LESSON:')
    console.log(this.lesson)
  }
}
</script>
